import { h, Component } from 'preact'
import TermsAPI from '../api/TermsAPI'
import ErrorMessage from '../components/ErrorMessage'
import Loader from '../components/Loader'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class CheckboxFilter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      terms: [],
      error: false,
      isLoading: true
    }

    this.handleTerm = this.handleTerm.bind(this)
  }

  componentDidMount() {
    this.fetchTerms()
  }

  fetchTerms() {
    this.setState({ isLoading: true })

    TermsAPI.all(this.props.taxonomy)
    .then(response => response.json())
    .then(data => {
      this.setState({
        terms: [...this.state.terms, ...data],
        isLoading: false
      })
    }).catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  handleTerm(e) {
    let values = []
    let current = parseInt(e.target.value)
    let index = 0

    // create array of integer choices IF anything has been checked
    if ( this.props.currentTerms  ) {
      values = this.props.currentTerms.split(',') // '12,13' > ['12','13']
      values = values.map((x) =>parseInt(x)) // ['12','13'] > [12,13]
    }

    // remove current choice IF already inside array
    if (values.includes(current) ) {
      index = values.indexOf(current)
      values.splice(index, 1)

    // add choice to array IF not already inside array
    } else {
      values.push(current)
    }

    // turn array back to string
    values = values.join(',')

    this.props.onSelectTerm(values, this.props.taxonomy)
  }

  generateCheckboxButtons(actives) {
    let options = []
    
    // turn active terms into an array of integers
    if ( actives.includes(',') ) {
      actives = actives.split(',') // '12,13' > ['12','13']
      actives = actives.map((x) =>parseInt(x)) // ['12','13'] > [12,13]
    }

    // make an option for each term
    this.state.terms.map((term) => {

      // skip term if it has no posts
      if ( term.count === 0 ) return false

      return options.push(
        <div className="c-checkbox">
          <input 
            type="checkbox" 
            value={term.id} 
            key={term.id} 
            id={term.id} 
            checked={actives.includes(term.id) ? true : false} 
            onChange={this.handleTerm}
            disabled={(this.props.postsLoading) ? true : false}
            className="c-checkbox__element"
          />
          <label 
            for={term.id} 
            dangerouslySetInnerHTML={{ __html: term.name }}
            className="c-checkbox__label"
          />
        </div>
      )
    })

    return options
  }

  render() {
    let {error, isLoading} = this.state

    if (error) {
      return <ErrorMessage type="filter-error" />
    }

    if (isLoading) {
      return <Loader />
    }

    return (
      <div className="c-projects-checkbox-filter">
        <h5
          dangerouslySetInnerHTML={{ __html: this.props.title }}
          className="c-projects-checkbox-filter__title" 
        />
        <div className="c-projects-checkbox-filter__buttons">
          { this.generateCheckboxButtons(this.props.currentTerms) }
        </div>
      </div>
    )
  }

}

export default CheckboxFilter



// WEBPACK FOOTER //
// ./src/js/projects/containers/CheckboxFilter.js